var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audioTrack-box",style:({ width: _vm.audioDuration * (40+(_vm.secWidth*10)) + 'px' }),on:{"mousedown":function($event){$event.stopPropagation();}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audioTrack-one"},[_c('div',{staticClass:"audioTrackColor"}),_c('div',{staticClass:"audioTrackImage"})])
}]

export { render, staticRenderFns }